import React, { useEffect, useContext, useState } from "react";
import "./SettingScreen.css";
import { ScreenContext } from "./App";

import musicTitle from "./Assets/Images/AppDashboard/SettingScreen/MUSIC.png";
import soundTitle from "./Assets/Images/AppDashboard/SettingScreen/Sound.png";
import musicIcon from "./Assets/Images/AppDashboard/SettingScreen/musicIcon.png";
import soundIcon from "./Assets/Images/AppDashboard/SettingScreen/soundIcon.png";
import descreaseBtn from "./Assets/Images/AppDashboard/PlayerSelectionScreen/decreaseBtn.png";
import increaseBtn from "./Assets/Images/AppDashboard/PlayerSelectionScreen/increaseBtn.png";
import slider from "./Assets/Images/AppDashboard/SettingScreen/slider.png";
import sliderHolder from "./Assets/Images/AppDashboard/SettingScreen/sliderHolder.png";

import LobbyScreen from "./LobbyScreen";
import {
  handleZIndexChangeLobbyExport,
  InitializeLobbyDataExport,
} from "./LobbyScreen";

let setSelectedGameModeExport;
let handleSettingZIndexChangeExport;

const SettingScreen = () => {
  const [musicValue, setMusicValue] = useState(39);
  const [soundValue, setSoundValue] = useState(39);
  const [zIndex, setZIndex] = useState(-999); // Initial z-index value
  const [selectedPlayersCount, setselectedPlayersCount] = useState(2);
  const handleScreenChange = useContext(ScreenContext);

  const [selectedGameMode, setSelectedGameMode] = useState("");

  // console.log(`Game Mode Player Selection Screen ====> ${selectedGameMode}`);

  const BACK = () => {
    // handleScreenChange('Home'); // Change to the 'Game' screen
    handleZIndexChange();
  };

  const [musicSliderValue, setMusicSliderValue] = useState(0); // Initial slider value
  const musicSliderMinValue = 0; // Minimum slider value
  const musicSliderMaxValue = 100; // Maximum slider value

  const [soundSliderValue, setSoundSliderValue] = useState(0); // Initial slider value
  const soundSliderMinValue = 0; // Minimum slider value
  const soundSliderMaxValue = 100; // Maximum slider value

  //====================================>
  //Function to Render FortfietScreen
  //====================================>
  const handleZIndexChange = (isAutoPlayDice) => {
    console.log(`Is Auto Play Dice ====> ${isAutoPlayDice}`);
    // Change the z-index value
    setZIndex((prevZIndex) => (prevZIndex === 999 ? -999 : 999));
  };

  // Function to handle increasing the music slider value
  const handleMusicIncrease = () => {
    if (musicSliderValue < musicSliderMaxValue) {
      setMusicSliderValue((prevValue) => prevValue + 20);
    }
  };

  // Function to handle decreasing the music slider value
  const handleMusicDecrease = () => {
    if (musicSliderValue > musicSliderMinValue) {
      setMusicSliderValue((prevValue) => prevValue - 20);
    }
  };

  // Function to handle increasing the sound slider value
  const handleSoundIncrease = () => {
    if (soundSliderValue < soundSliderMaxValue) {
      setSoundSliderValue((prevValue) => prevValue + 20);
    }
  };

  // Function to handle decreasing the sound slider value
  const handleSoundDecrease = () => {
    if (soundSliderValue > soundSliderMinValue) {
      setSoundSliderValue((prevValue) => prevValue - 20);
    }
  };

  // Function to calculate the position of the slider holder based on the current value
  const calculateSliderPosition = (value, minValue, maxValue) => {
    const range = maxValue - minValue;
    const percentage = ((value - minValue) / range) * 100;
    return Math.max(0, Math.min(100, percentage)); // Ensure the position is within bounds
  };

  handleSettingZIndexChangeExport = handleZIndexChange;

  const [sliderMusicValue, setSliderMusicValue] = useState(50); // Default value
  const [sliderSoundValue, setSliderSoundValue] = useState(50); // Default value

  const handleSliderMusicChange = (event) => {
    setSliderMusicValue(event.target.value);
  };
  const handleSliderSoundChange = (event) => {
    setSliderSoundValue(event.target.value);
  };

  return (
    <>
      <div
        className="setting-screen"
        style={{ zIndex, visibility: zIndex === -999 ? "hidden" : "visible" }}
      >
        <div className="setting-wrapper" style={{ width: "46%" }}>
          <img
            src={require("./Assets/Images/AppDashboard/SettingScreen/SettingScreenPanel.png")}
            alt="settingScreenPanel"
            className="setting-panel"
          />

          <img
            src={require("./Assets/Images/AppDashboard/backBtn.png")}
            alt="backBtn"
            style={{
              width: "3%",
              height: "auto",
              position: "absolute",
              top: "13%",
              left: "85%",
              transform: "translate(-50%, -50%)",
            }}
            onClick={BACK}
          />
   
          <img
            src={musicTitle}
            alt="musicTitle"
            style={{
              position: "absolute",
              width: "10%",
              height: "auto",
              top: "40%",
              left: "45%",
            }}
          />
          <img
            src={musicIcon}
            alt="musicIcon"
            style={{
              width: "5%",
              position: "absolute",
              top: "50%",
              left: "25%",
            }}
          />
          <img
            onClick={() => {
              setSliderMusicValue(sliderMusicValue > 0 ? sliderMusicValue-10 : sliderMusicValue)
            }}
            src={descreaseBtn}
            alt="Decrease"
            style={{
              width: "5%",
              position: "absolute",
              top: "50%",
              left: "32%",
            }}
          />
          <div className="slider_div">
          <input type="range" min="1" max="100" value={sliderMusicValue} className="slider" id="myRange" onChange={handleSliderMusicChange} />
          </div>
          {/* <img
            src={slider}
            alt="slider"
            style={{
              width: "20%",
              position: "absolute",
              top: "53%",
              left: "40%",
            }}
          />
          <img
            src={sliderHolder}
            alt="Slider Holder"
            style={{
              width: "4%",
              position: "absolute",
              top: "51%",
              left: musicValue + "%",
              // left: "35%",
            }}
          /> */}
          <img
            onClick={() => {
              setSliderMusicValue(sliderMusicValue < 100 ? sliderMusicValue + 10 : sliderMusicValue)
            }}
            src={increaseBtn}
            alt="increaseBtn"
            style={{
              width: "5%",
              position: "absolute",
              top: "50%",
              left: "65%",
            }}
          />
          <div
            style={{
              display: "flex",
              position: "absolute",
              width: "50%",
              top: "50%",
              left: "25%",
              gap: "25px",
            }}
          ></div>
          {/* Sound */}
          <img
            src={soundTitle}
            alt="soundTitle"
            style={{
              position: "absolute",
              width: "10%",
              height: "auto",
              top: "65%",
              left: "45%",
            }}
          />
          <img
            src={soundIcon}
            alt="musicIcon"
            style={{
              width: "5%",
              position: "absolute",
              top: "75%",
              left: "25%",
            }}
          />
          <img
            onClick={() => {
              setSliderSoundValue(sliderSoundValue > 0 ? sliderSoundValue - 10 : sliderSoundValue)
            }}
            src={descreaseBtn}
            alt="Decrease"
            style={{
              width: "5%",
              position: "absolute",
              top: "75%",
              left: "32%",
            }}
          />
           <div className="slider_div_2">
          <input type="range" min="1" max="100" value={sliderSoundValue} className="slider" id="myRange" onChange={handleSliderSoundChange} />
          </div>
          <img
            onClick={() => {
              setSliderSoundValue(sliderSoundValue < 100 ? sliderSoundValue + 10 : sliderSoundValue)
            }}
            src={increaseBtn}
            alt="increaseBtn"
            style={{
              width: "5%",
              position: "absolute",
              top: "75%",
              left: "65%",
            }}
          />
          <div
            style={{
              display: "flex",
              position: "absolute",
              width: "50%",
              top: "75%",
              left: "25%",
              gap: "25px",
            }}
          ></div>

          {/* <div
          className="slider-container"
          style={{
            position: "absolute",
            width: "10%",
            height: "auto",
            top: "50%",
            left: "35%",
          }}
        >
          <img
            src={musicIcon}
            alt="musicIcon"
            style={{
              position: "relative",
              width: "50%",
              height: "auto",
              top: "40%",
              left: "-100%",
            }}
          />

          <button className="decrease-btn" onClick={handleMusicDecrease}>
            <img
              src={descreaseBtn}
              alt="Decrease"
              style={{
                position: "absolute",
                width: "50%",
                height: "auto",
                top: "0%",
                left: "-10%",
              }}
            />
          </button>

          <div className="slider-bg">
            <img src={slider} alt="Slider Background" />
          </div>
          <div
            className="slider-holder"
            style={{
              top: "15%",
              left: `${
                calculateSliderPosition(
                  musicSliderValue,
                  musicSliderMinValue,
                  musicSliderMaxValue
                ) *
                  2.55 +
                44
              }%`,
            }}
          >
            <img src={sliderHolder} alt="Slider Holder" />
          </div>
          <button className="increase-btn" onClick={handleMusicIncrease}>
            <img
              src={increaseBtn}
              alt="Increase"
              style={{
                position: "absolute",
                width: "50%",
                height: "auto",
                top: "0%",
                left: "335%",
              }}
            />
          </button>
        </div> */}

          {/* <div
          className="slider-container"
          style={{
            position: "absolute",
            width: "10%",
            height: "auto",
            top: "75%",
            left: "35%",
          }}
        >
          <img
            src={soundIcon}
            alt="soundIcon"
            style={{
              position: "relative",
              width: "50%",
              height: "auto",
              top: "50%",
              left: "-100%",
            }}
          />

          <button className="decrease-btn" onClick={handleSoundDecrease}>
            <img
              src={descreaseBtn}
              alt="Decrease"
              style={{
                position: "absolute",
                width: "50%",
                height: "auto",
                top: "0%",
                left: "-10%",
              }}
            />
          </button>

          <div className="slider-bg">
            <img src={slider} alt="Slider Background" />
          </div>
          <div
            className="slider-holder"
            style={{
              top: "15%",
              left: `${
                calculateSliderPosition(
                  soundSliderValue,
                  soundSliderMinValue,
                  soundSliderMaxValue
                ) *
                  2.55 +
                44
              }%`,
            }}
          >
            <img src={sliderHolder} alt="Slider Holder" />
          </div>
          <button className="increase-btn" onClick={handleSoundIncrease}>
            <img
              src={increaseBtn}
              alt="Increase"
              style={{
                position: "absolute",
                width: "50%",
                height: "auto",
                top: "0%",
                left: "335%",
              }}
            />
          </button>
        </div> */}
        </div>
      </div>
    </>
  );
};

export { handleSettingZIndexChangeExport };

export default SettingScreen;
